import { FC } from 'react';
import { Drawer, List } from '@mui/material';
import { useAppContext } from '@/context/App.context';
import { useTranslation } from 'react-i18next';

import { MobileList, MobileListItemInterface } from '../MobileList/MobileList';
import { SideBarNavigationMobile } from './SideBarNavigation.styles';
import { useSelectIsMenuOpen, useSetIsMenuOpen } from '@/store/useAppStore';

export const SideBarNavigation: FC = () => {
  const { isLoggedIn } = useAppContext();
  const { t } = useTranslation();
  const isMenuOpen = useSelectIsMenuOpen();
  const setIsMenuOpen = useSetIsMenuOpen();

  const dashboardMobileItems: MobileListItemInterface[] = [
    ...(isLoggedIn
      ? [
          { link: '/dashboard', label: t('menuLabels.dashboard') },
          { link: `/dashboard/results`, label: t('menuLabels.results') },
          { link: `/dashboard/practice`, label: t('menuLabels.practice') }
        ]
      : []),
    {
      link: `/${isLoggedIn ? 'dashboard/' : ''}test-format`,
      label: t('menuLabels.testFormats')
    },
    {
      link: `/${isLoggedIn ? 'dashboard/' : ''}for-institutions`,
      label: t('menuLabels.forInstitutions')
    }
  ];

  return (
    <Drawer
      sx={SideBarNavigationMobile(!!isLoggedIn)}
      open={isMenuOpen}
      variant='temporary'
      anchor='right'
    >
      <List>{MobileList(dashboardMobileItems, setIsMenuOpen)}</List>
    </Drawer>
  );
};
